<div class="container" style="padding-right: 0px;">
    <div class="row">
      <div class="col-2 form-switch">
        <input class="switch-form-default form-check-input" type="checkbox" id="enableRequest" name="naam" checked disabled>
      </div>
      <div class="col-6 form-check">
        <label for="enableRequest" class="form-check-label text-break pr-1 pl-1">
            {{ request.requestName }}
        </label>
      </div>
      <div class="col-4">
        <div class="float-end">
            <pillbadge-status-display [data]="statusBadge" [status]="statusIndicator" [iconTag]="''"
            [disable]="false"></pillbadge-status-display>
        </div>
      </div>
    </div>
</div>
